<script>
  import { onMount } from "svelte";
  import { HsvPicker } from "svelte-color-picker";
  import { colorHistory, saveColorHistory, systemLog } from "../../editor/storage.js";
  import { parseRGBA, encodeRGBhex } from "../../editor/component/mark.js";
  export let color;
  export let afterPick;
  export let closer;
  export let x = "530px";
  export let y = "350px";
  let eventColor;
  let fixedColor;
  onMount(() => {
    if (color?.constructor.name === "String" && color.startsWith("$")) {
      fixedColor = "#000000";
      eventColor = { r: 0, g: 0, b: 0, a: 1 };
    } else if (
      color?.constructor.name === "String" &&
      color.startsWith("rgba(")
    ) {
      fixedColor = encodeRGBhex(parseRGBA(color));
      eventColor = parseRGBA(color);
    } else if (color?.startsWith("#") && color.length == 7) {
      fixedColor = encodeRGBhex(parseRGBA(color));
      eventColor = parseRGBA(color);
    }
  });
  let panel;
  function adjustPosition(node) {
    let moved = {};

    node.addEventListener("mousedown", (event) => {
      // start
      if (event.target.classList.contains("window-drag")) {
        moved.ing = true;
        moved.ox = event.clientX;
        moved.oy = event.clientY;
        moved.px = parseFloat(panel.style.left);
        moved.py = parseFloat(panel.style.top);
      }
    });
    window.addEventListener("mouseup", (event) => {
      moved.ing = false;
    });
    window.addEventListener("mousemove", (event) => {
      if (moved.ing) {
        moved.dx = event.clientX - moved.ox;
        moved.dy = event.clientY - moved.oy;
        node.style.left = moved.px + moved.dx + "px";
        node.style.top = moved.py + moved.dy + "px";
      }
    });
  }
  colorHistory.subscribe((colors) => {
    saveColorHistory(colors);
  });
  function updateColor(c) {
    colorHistory.update((colors) => {
      if (!colors.map((color) => colorString(color)).includes(colorString(c)))
        colors.unshift(c);
      if (colors.length > 30) colors = colors.slice(0, 30);
      return colors;
    });
    $systemLog.log({message: "Picked a new color", color: c});
  }
  function colorString(c) {
    return `rgba(${c.r},${c.g},${c.b},${c.a})`;
  }
  function setColor(c) {
    eventColor = c;
  }
</script>

<div
  class="dupo-menu-pane dupo-third-panel"
  style={`left: ${x}; top: ${y}; width: 274px;`}
  bind:this={panel}
  use:adjustPosition
>
  <div class="dupo-menu-pane-row pt-2">
    <h3 class="window-drag">
      <i class="bi bi-paint-bucket me-1" /> Color picker
    </h3>
    <i class="bi bi-x closer" on:click={closer} />
  </div>
  <div>
    {#if fixedColor?.startsWith("#") && fixedColor.length == 7}
      <!-- fix! -->
      <HsvPicker
        on:colorChange={(event) => {
          eventColor = event.detail;
        }}
        startColor={fixedColor}
      />
    {/if}
  </div>
  <div class="dupo-menu-pane-row pt-2 color-chips-wrap">
    {#each $colorHistory as color}
      <div class="picker-chip">
        <button
          type="button"
          on:click={() => {
            setColor(color);
            updateColor(eventColor);
            afterPick({ detail: eventColor });
            closer();
          }}
          style={"background-color: " + colorString(color) + ";"}
          >Choose {colorString(color)} from history</button
        >
      </div>
    {/each}
  </div>
  <div class="dupo-menu-pane-button-row my-2">
    <button
      type="button"
      class="okay"
      on:click={(event) => {
        updateColor(eventColor);
        afterPick({ detail: eventColor });
        closer();
      }}>Okay</button
    >
  </div>
</div>

<style>
  :global(.color-info-box .text) {
    margin-top: -13px !important;
  }
  :global(.color-picked-bg > .color-picked) {
    margin: -5px 0 2px -2px !important;
  }
  :global(.color-info-box .text),
  :global(.color-info-box .text-label) {
    font-family: "Merriweather Sans", "Cabin", "Source Sans Pro", "Roboto",
      "Arial", sans-serif;
  }
  button.okay {
    width: 100%;
    appearance: none;
    border-width: 1px 0 0 0;
    border-top: 1px solid black;
    background-color: white;
    text-align: cetner;
  }
  button.okay:hover {
    background-color: rgba(0, 0, 0, 0.085);
  }
  .color-chips-wrap {
    display: flex;
    flex-wrap: wrap;
    gap: 2.5px 2.5px;
  }
  .picker-chip {
    width: 16px;
    height: 16px;
  }
  .picker-chip button {
    width: 16px;
    height: 16px;
    border: 1px solid #dddddd;
    border-radius: var(--default-radius);
    font-size: 0;
  }
  .picker-chip button:hover {
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
  }
</style>
